export default "__VITE_ASSET__wbBD2X8y__"